import EventActionProto from '../event-action-proto'

module.exports = class EventStatusNew extends EventActionProto {

    constructor(uid, data) {
        super(uid, data)
    }

    validate() {
        return true
    }

    process() {
        _.map(this.data, s=>{
            if (!gd.session.statuses.get(s['id'])) {
                gd.session.statuses.add([s],{parse:true})
                // add
            } else {
                // update
                gd.session.statuses.get(s['id']).set({
                    name: s['name'],
                    color: s['color'],
                    isDeleted: s['isDeleted']
                })
            }
        })

        super.process()
    }
}

